import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const PointIcon: FC<IconType> = (props) => {
  const { width, height, color, dataTestId } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      data-test-id={dataTestId}
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2z" />
    </svg>
  );
};
